import Documento from './Documento.js';

var DocumentoPublic = Object.create(Documento);

DocumentoPublic.model = 'public/documento';

export default DocumentoPublic;